import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ArrowBack_Icon from '../../assets/images/svgs/arrow-back-white.svg'
import follow from '../../assets/images/svgs/follow.svg'
import More from '../../assets/images/svgs/more.svg'
import unfollow from '../../assets/images/svgs/unfollow.svg'
import { Button } from '../../components/button'
import Percentage from '../../components/percentage'
import Photo_Buttons from '../../components/photo-buttons'
import {
    followFeatures,
    getCorporateDetailsByName,
    unfollowFeatures,
} from '../../services/api'
import { changeScreen } from '../../store/auth/auth-action'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { setMoreInfo, setNumberButton } from '../../store/impact/impact-action'
import { Accreditations, CorporatePartner } from '../../types/api'
import './styles.scss'

const Corporate_Details = () => {
    const params = useParams()
    const { isMore } = useAppSelector((state) => state.impact)
    const { access_token } = useAppSelector((state) => state.auth)
    const { inScreen } = useAppSelector((state) => state.following)
    const dispatch = useAppDispatch()
    const [details, setDetails] = useState<CorporatePartner>(
        {} as CorporatePartner
    )
    const [loaded, setloaded] = useState<boolean>(false)
    const [secondMore, setSecondMore] = useState<boolean>(false)
    const [showInfo, setShowInfo] = useState<boolean>(false)
    const [favorite, setFavorite] = useState<boolean>(false)
    const navigate = useNavigate()

    const _getCorporateDetails = async () => {
        setSecondMore(false)
        setloaded(true)
        const data: CorporatePartner = await getCorporateDetailsByName(
            access_token.access_token,
            params.brandName!.replaceAll('_', ' ')
        )
        setloaded(false)
        setDetails(data)
        setFavorite(data.is_favorite!)
    }
    const _more = () => {
        dispatch(setMoreInfo(true))
        setSecondMore(true)
    }
    const _follow = async () => {
        if (!favorite) {
            await followFeatures(access_token.access_token, details.id)
        } else {
            await unfollowFeatures(access_token.access_token, details.id)
        }
        setFavorite(!favorite)
    }
    const _openAccreditations = (link: string) => {
        window.open(link, '_blank')
    }
    const _hideInfoModal = () => {
        if (secondMore) {
            dispatch(setMoreInfo(true))
        }
        setShowInfo(false)
    }
    const _showInfoModal = () => {
        dispatch(setMoreInfo(false))
        setShowInfo(true)
    }
    const _openSlider = (e: number) => {
        dispatch(setNumberButton(e))
        dispatch(changeScreen('Corporate Details Slider'))
    }
    const _closeModal = () => {
        if (inScreen) {
            dispatch(changeScreen('Following'))
        } else {
            document.body.style.overflow = 'visible'
            navigate('/')
        }
        dispatch(setMoreInfo(false))
        window.history.replaceState('object or string', 'title', '/')
    }
    const integer = (number: number) => {
        if (Number.isInteger(number)) {
            return `${number}%`
        } else {
            const newNumber = number.toFixed(1)
            const k = (Number(newNumber) * 10) % 10
            if (k === 0) {
                return `${number.toFixed(0)}%`
            } else {
                return `${number.toFixed(1)}%`
            }
        }
    }
    const _getLink = async (link: string) => {
        const newLink =
            !link.startsWith('www.') && !link.startsWith('https://')
                ? 'https://' + link
                : link.startsWith('www')
                ? link.replace('www.', 'https://')
                : link
        window.open(newLink, '_blank')
    }
    useEffect(() => {
        _getCorporateDetails()
    }, [params.brandName])

    const proofPointsFoundList =
        details?.last_signed_off_worker?.proof_points_found_list
    const isLogosProofPointsFoundList =
        proofPointsFoundList &&
        proofPointsFoundList.filter((e) => e.proof_points?.logo?.url).length > 0

    return (
        <div className="corporate-details">
            <div className="corporate-details__backarrow" onClick={_closeModal}>
                <img src={ArrowBack_Icon} />
            </div>
            <div className="corporate-details__image-container">
                <img
                    className="corporate-details__img"
                    src={details?.photo?.url}
                />
                <Photo_Buttons
                    data={details}
                    className={'photo-button-details'}
                    onClick={_openSlider}
                />
                <div className="corporate-details__photo-name">
                    {details?.name}
                </div>
            </div>
            <div className="corporate-details__follow-percent">
                <div onClick={_follow} className="corporate-details__follow">
                    <img src={favorite ? unfollow : follow} />
                    <p className="corporate-details__follow_text">
                        {favorite ? 'Unfollow' : 'Follow'}
                    </p>
                </div>
                <div
                    className={
                        details?.affiliate_percent
                            ? 'corporate-details__percent'
                            : 'corporate-details__percent-false'
                    }
                >
                    <p
                        className="corporate-details__percent_text"
                        onClick={_showInfoModal}
                    >
                        {details?.affiliate_percent
                            ? integer(details?.affiliate_percent)
                            : ''}
                    </p>
                </div>
            </div>
            <div
                className={
                    isMore
                        ? 'corporate-details__description_true'
                        : 'corporate-details__description_false'
                }
                dangerouslySetInnerHTML={{ __html: details?.description }}
            ></div>
            {!isMore && (
                <div
                    className="corporate-details__description__more"
                    onClick={_more}
                >
                    <p>MORE</p>
                    <img src={More} />
                </div>
            )}
            <div className="corporate-details__accreditations-container">
                {isLogosProofPointsFoundList && (
                    <>
                        <p>ACCREDITATIONS</p>
                        <div className="corporate-details__accreditations">
                            {proofPointsFoundList.map((e, index) => {
                                const logoUrl = e?.proof_points?.logo?.url
                                if (!logoUrl) {
                                    return null
                                }
                                return (
                                    <img
                                        key={e.id || `${index}_acc`}
                                        onClick={() => {
                                            if (e?.proof_points?.website_url) {
                                                _openAccreditations(
                                                    e.proof_points.website_url
                                                )
                                            } else {
                                                console.error(
                                                    'website_url does not exit'
                                                )
                                            }
                                        }}
                                        className="corporate-details__accreditations_icon"
                                        src={logoUrl}
                                    />
                                )
                            })}
                        </div>
                    </>
                )}
            </div>
            <div className="corporate-details__button">
                <Button
                    variant="black"
                    text="SHOP"
                    onClick={() => {
                        _getLink(
                            details.affiliate_link!
                                ? details.affiliate_link!
                                : details.site!
                        )
                    }}
                />
            </div>
            {showInfo && <Percentage hideInfo={_hideInfoModal} />}
        </div>
    )
}
export default Corporate_Details
